import React, { PropsWithChildren, useCallback, useState } from 'react';
import { InfoDict } from '../Questions/Props';

export const useApplicant = () => {
  const context = React.useContext(ApplicantContext);
  if (!context) {
    throw new Error('useApplicant must be used within a ApplicantContextProvider')
  }
  return context
}

type ApplicantProviderProps = {
  children: React.ReactNode,
  context: ApplicantContextType
}

type ApplicantContextType = {
  update(info: InfoDict): void,
  info: InfoDict
}

export const ApplicantContext = React.createContext<ApplicantContextType>({
  info: {},
  update(info) { console.warn("no info setter specified, ignoring:", info); },
});

export const ApplicantProvider: React.FC<ApplicantProviderProps> = ({ children, context }) => {
  return (
    <ApplicantContext.Provider value={context}>
      {children}
    </ApplicantContext.Provider>
  )
}
